document.addEventListener('DOMContentLoaded', () => {

  // External Links Warning
  const handleExternalLinks = () => {
    const links = document.querySelectorAll('a');
    const excludedLinks = [];

    const isThirdParty = (url) => {
      try {
        const linkHost = new URL(url).hostname;
        const currentHost = window.location.hostname;
        return linkHost && linkHost !== currentHost;
      } catch (e) {
        return false;
      }
    };

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isThirdParty(href) || excludedLinks.includes(href)) return;

      link.setAttribute('target', '_blank');

      const existingText = link.textContent.trim();
      const ariaLabel = `${existingText}, Redirecting to a third-party website (opens in a new tab)`;
      link.setAttribute('aria-label', ariaLabel);

      const img = link.querySelector('img, svg');
      if (img) {
        let altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, Redirecting to a third-party website (opens in a new tab)`
          : 'Redirecting to a third-party website (opens in a new tab)';
        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  // Email & Phone Links
  const handleContactLinks = () => {
    const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');

    links.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email Address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  // Remove unwanted aria-labelledby
  const removeAriaLabelledby = () => {
    document.querySelectorAll('.card__heading a, .card__heading.h3 a, .card__heading h3, .card__heading.h3 a.full-unstyled-link')
      .forEach(el => el.removeAttribute('aria-labelledby'));
  };

  // Remove aria-describedby
  const removeAriaDescribedby = () => {
    document.querySelectorAll('.thumbnail.global-media-settings.global-media-settings--no-shadow, .yotpo-widget-clear')
      .forEach(el => el.removeAttribute('aria-describedby'));
  };

  // Add aria-hidden to <br>
  const hideBrFromScreenReaders = () => {
    document.querySelectorAll('br').forEach(br => {
      br.setAttribute('aria-hidden', 'true');
    });
  };

  // Remove tabindex from mega menu
  const fixMegaMenuTabindex = () => {
    document.querySelectorAll('.js .mega-menu__content').forEach(el => {
      el.removeAttribute('tabindex');
    });
  };

  // Run immediate fixes
  handleExternalLinks();
  handleContactLinks();
  hideBrFromScreenReaders();
  fixMegaMenuTabindex();

  // Run delayed fixes (replacing multiple setTimeouts)
  setTimeout(() => {
    removeAriaLabelledby();
    removeAriaDescribedby();
  }, 1000);

});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("slideshow-component").forEach(function (sliderComponent) {
    const slides = sliderComponent.querySelectorAll(".slideshow__slide");
    const nav = sliderComponent.querySelector(".slideshow-nav");

    if (!nav) return;

    if (slides.length <= 1) {
      nav.style.display = "none";
      nav.setAttribute("aria-hidden", "true");
    } else {
      nav.style.display = "";
      nav.removeAttribute("aria-hidden");
    }
  });
});
